import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import styles from './Audio.css';


class Audio extends Component {
  constructor(props) {
    super(props);
  }

  podcastClicked() {
    window.location.href = this.props.podcast;
  }

  render() {
    return (
      <div
        className={styles.Audio}>
        <div className={styles.AudioPlayer}>
          <audio src={`/task/ngsl/audio/${this.props.taskid}.mp3`} controls>
          </audio>
        </div>

        {this.props.podcast && <Button onClick={e => this.podcastClicked()}>
          Podcastで聞く
        </Button>}
      </div>
    );
  }
}

export default Audio;
